<template>
  <div class="container mx-auto py-6">
    <Toast />
    <ConfirmDialog />
    <div class="bg-white rounded-lg shadow-lg p-6">
      <div class="mb-4">
        <button @click="goBack" class="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium mb-4">
          <i class="pi pi-arrow-left mr-2"></i> Kembali
        </button>
      </div>
      <div class="mb-6">
        <h2 class="text-2xl font-semibold">Daftar Sanggah</h2>
        <p class="text-gray-600">{{ dokumenPengadaan.nama }}</p>
      </div>

      <div v-if="$page.props.flash.message" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
        {{ $page.props.flash.message }}
      </div>

      <div v-if="sanggahs.length === 0" class="text-center py-8">
        <div class="bg-green-50 border border-green-200 rounded-lg p-6">
          <i class="pi pi-check-circle text-green-500 text-4xl mb-4"></i>
          <h3 class="text-lg font-semibold text-green-800 mb-2">Tidak Ada Sanggah Yang Perlu Diproses</h3>
          <p class="text-green-700">Semua sanggah telah diproses atau belum ada sanggah yang masuk untuk dokumen pengadaan ini.</p>
        </div>
      </div>
      
      <div v-else class="overflow-x-auto">
        <table class="min-w-full table-auto">
          <thead>
            <tr class="bg-gray-100">
              <th class="px-4 py-2 text-left">No</th>
              <th class="px-4 py-2 text-left">Penyanggah</th>
              <th class="px-4 py-2 text-left">Alasan</th>
              <th class="px-4 py-2 text-left">Status</th>
              <th class="px-4 py-2 text-left">Jawaban</th>
              <th class="px-4 py-2 text-left">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sanggah, index) in sanggahs" :key="sanggah.id" class="border-b">
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2">{{ sanggah.penyedia}}</td>
              <td class="px-4 py-2" v-html="sanggah.alasan"></td>
              <td class="px-4 py-2">
                <span :class="{
                  'px-2 py-1 rounded text-sm': true,
                  'bg-yellow-100 text-yellow-800': sanggah.status == 'proses',
                  'bg-green-100 text-green-800': sanggah.status == 'diterima',
                  'bg-red-100 text-red-800': sanggah.status == 'ditolak'
                }">
                  {{ sanggah.status }}
                </span>
              </td>
              <td class="px-4 py-2" v-html="sanggah.jawaban || '-'"></td>
              <td class="px-4 py-2">
                <div v-if="sanggah.status === 'proses'" class="space-x-2">
                  <Link :href="route('sanggah.process', [dokumenPengadaan.id, sanggah.id])">
                    <button
                      class="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                    >
                      Terima
                    </button>
                  </Link>
                  <button
                    @click="openResponseModal(sanggah, 'ditolak')"
                    class="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  >
                    Tolak
                  </button>
                </div>
                <div v-else class="space-x-2">
                  <button
                    @click="resetStatus(sanggah)"
                    class="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                  >
                    Reset
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Response Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div class="bg-white p-6 rounded-lg w-full max-w-2xl">
        <h3 class="text-lg font-semibold mb-4">
          {{ selectedStatus === 'diterima' ? 'Terima' : 'Tolak' }} Sanggah
        </h3>
        <div class="mb-4">
          <label class="block text-sm font-medium mb-1">Jawaban</label>
          <div class="bg-white">
            <QuillEditor
              v-model:content="responseText"
              contentType="html"
              theme="snow"
              toolbar="full"
              :options="{
                modules: {
                  toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'align': [] }],
                    ['clean']
                  ]
                }
              }"
              style="height: 200px"
            />
          </div>
        </div>
        <div class="flex justify-end space-x-2 mt-4">
          <button
            @click="closeModal"
            class="px-4 py-2 border rounded hover:bg-gray-100"
          >
            Batal
          </button>
          <button
            @click="submitResponse"
            class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import { Link } from '@inertiajs/inertia-vue3'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from 'primevue/useconfirm'
import ConfirmDialog from 'primevue/confirmdialog'

export default {
  components: {
    Link,
    QuillEditor,
    Toast,
    ConfirmDialog
  },

  props: {
    dokumenPengadaan: Object,
    sanggahs: Array,
  },

  setup() {
    const toast = useToast();
    const confirm = useConfirm();
    return { toast, confirm }
  },

  data() {
    return {
      showModal: false,
      selectedSanggah: null,
      selectedStatus: null,
      responseText: '',
    }
  },

  methods: {
    goBack() {
      window.history.length > 1 ? window.history.back() : this.$inertia.visit('/dokumen_pengadaan');
    },

    openResponseModal(sanggah, status) {
      this.selectedSanggah = sanggah
      this.selectedStatus = status
      this.responseText = ''
      this.showModal = true
    },

    closeModal() {
      this.showModal = false
      this.selectedSanggah = null
      this.selectedStatus = null
      this.responseText = ''
    },

    resetStatus(sanggah) {
      this.confirm.require({
        message: 'Apakah anda yakin ingin mereset status sanggah ini?',
        header: 'Konfirmasi Reset Status',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          Inertia.post(`/sanggah/${sanggah.id}/status`, {
            status: 'proses',
          }, {
            onSuccess: () => {
              this.toast.add({
                severity: 'success',
                summary: 'Berhasil',
                detail: 'Status sanggah berhasil direset',
                life: 3000
              });
            },
            onError: () => {
              this.toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Terjadi kesalahan saat mereset status sanggah',
                life: 3000
              });
            }
          });
        }
      });
    },

    submitResponse() {
      if (!this.responseText.trim()) {
        this.toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Jawaban harus diisi',
          life: 3000
        });
        return
      }

      const status = this.selectedStatus;
      Inertia.post(`/sanggah/${this.selectedSanggah.id}/status`, {
        status: status,
        jawaban: this.responseText,
      }, {
        onSuccess: () => {
          this.toast.add({
            severity: 'success',
            summary: 'Berhasil',
            detail: `Sanggah berhasil ${status === 'diterima' ? 'diterima' : 'ditolak'}`,
            life: 3000
          });
        },
        onError: () => {
          this.toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Terjadi kesalahan saat memproses sanggah',
            life: 3000
          });
        }
      })

      this.closeModal()
    },
  },
}
</script>

<style>
.ql-container {
  min-height: 200px;
}
</style>
